#import '../fragment/reservedOa.graphql'

mutation saveReservedOa($reservedOa: ReservedOaInput!, $customerId: ID) {
  saveReservedOa(reservedOa: $reservedOa, customerId: $customerId) {
    ...reservedOaFragment
  }
}
